module.exports = __webpack_public_path__ + "img/tmx_kapcsolat_4.c67636c9.jpg";